import React, { Component } from 'react'
import { Input, FormFeedback, InputGroupAddon, InputGroup, InputGroupText, Form } from 'reactstrap';
import { otp, subscriber, csrOtp, csrSubscriber } from '../apis/accountManagementApis';
import Loading from '../../shared/Loading';
import EirErrorModal from '../EirErrorModal';
import EirButton from '../../eir-button/EirButton';

let subscriberStatus = '',
    otpStatus = ''

class EditMobileNumber extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: '',
            showEdit: true,
            showSave: false,
            std: '',
            invalid: false,
            verifyCode: false,
            verificationCode: '',
            uuid: '',
            Loading: false,
            errorModal: false,
            number: this.props.subscriber.number,
            invalidVerificationCode: false,
            stds: [
                "083",
                "085",
                "086",
                "087",
                "088",
                "089",
            ],
        }
    }

    toggleError = (param) => {
        this.setState({
            errorModal: param
        })
    }

    componentDidMount() {
        if (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN')  === '0_') {
            subscriberStatus = csrSubscriber;
            otpStatus = csrOtp;
        } else {
            subscriberStatus = subscriber;
            otpStatus = otp;
        }
    }
    

    handleEdit = (event) => {
        event.preventDefault();
        let value = this.props.subscriber.number.slice(this.props.subscriber.number.length - 7);
        let std = this.props.subscriber.number.slice(0, 3)
        this.setState({
            showSave: true,
            showEdit: false,
            value,
            std,
        })
    }

    handleCancel = (event) => {
        event.preventDefault();
        this.setState({
            showEdit: true,
            showSave: false,
            invalid: false,
            verifyCode: false,
            verificationCode: ''
        })
    }

    verification = (event) => {
        event.preventDefault()

        if (!this.state.invalid) {

            this.setState({
                verifyCode: true,
                invalidVerificationCode: false,
                loading: true
            })

            otpStatus.post(`/otp/`, {
                "msisdn": this.state.std.toString() + this.state.value.toString()
            })
                .then((response) => {
                    this.setState({
                        uuid: response.data.otpUuid,
                        loading: false,
                        number: this.state.std.toString() + this.state.value.toString(),
                    })
                })
                .catch((error) => {
                    this.setState({
                        errorModal: true,
                        loading: false,
                        verifyCode: false,
                    })
            })
        }        
    }

    handleVerificationCode = (event) => {
        this.setState({
            verificationCode: event.target.value
        })
    }

    submitVerificationCode = (event) => {
        event.preventDefault();

        this.setState({
            loading: true,
        })

        otpStatus.post(`/otp/${this.state.uuid}/validate`, {
            "otp": this.state.verificationCode
        })
            .then((response) => {
                subscriberStatus.post(`/subscriber/update`, {
                    'email': this.props.subscriber.email,
                    'name': this.props.subscriber.name,
                    'number': this.state.number,
                    'plan': this.props.subscriber.plan,
                    'terms': this.props.subscriber.terms
                })
            })
            .then((response) => {
                
                this.setState({
                    showEdit: true,
                    showSave: false,
                    verifyCode: false,
                    verificationCode: '',
                    loading: false
                })
                    this.props.updateMobileNumber(true);
            })
            .catch((error) => {
                if (error.response.data.errorCode === 'INCORRECT_CODE') {
                    this.setState({
                        invalidVerificationCode: true,
                        loading: false
                    })
                }
                else {
                    this.setState({
                        errorModal: true,
                        loading: false,
                        showEdit: true,
                        showSave: false,
                        invalid: false,
                        verifyCode: false,
                        verificationCode: ''
                    })
                }
            })
            .catch((error) => {
                this.setState({
                    errorModal: true,
                    loading: false
                })
            })

    }

    handleClick = (event) => {
        if (event.target.validity.valid) {
            this.setState({
                value: event.target.value,
                invalid: (event.target.value.length != 7) ? true : false
            })
        }
    }

    handleStd = (event) => {
        this.setState({
            std: event.target.value
        })
    }


    render() {
        const { value, showEdit, showSave, std, stds, invalid, verificationCode, invalidVerificationCode, errorModal, loading } = this.state;
        const { subscriber } = this.props
        return (
            <div className='update-mobile-main'>
                <Form onSubmit={this.verification}>
                <b>Mobile Number: </b>
                <span className='edit-mobile-std edit-mobile-form'>
                    {showSave &&
                        <Input
                            className='edit-mobile-std edit-mobile-form'
                            type="select"
                            value={std}
                            onChange={this.handleStd}>
                            {stds.map((stds, i) => <option key={i}>{stds}</option>)}
                        </Input>
                    }
                </span>
                {
                    showEdit && 
                    <span>
                        {subscriber.number} <EirButton type='link' text='Update' className="edit" onClick={this.handleEdit} />
                    </span>
                }
                {showSave &&
                <span>
                    <Input
                        className='edit-mobile-number edit-mobile-form'
                        value={value}
                        placeholder='Mobile Number'
                        onChange={this.handleClick}
                        type='tel'
                        name='number'
                        pattern='^[0-9]*$'
                        invalid={invalid}
                        // pass regular expression pattern="^[0-9]*$" to get only numbers
                        maxLength='7'
                    />
                    <FormFeedback className="m-0 p-0 text-center col-lg-12 float-right">
                        Please enter at least 7 characters
                    </FormFeedback>
                </span>
                }
                {showSave &&
                    <div>                        
                        {!this.state.verifyCode &&
                            <span className='saveCancelButton'>
                                <EirButton type='link' text='Send Verification Code' className="save" onClick={this.verification} />
                                <EirButton type='link' text='Cancel' className="cancel" onClick={this.handleCancel} />
                            </span>
                        }
                    </div>
                }
                </Form>

                {
                    this.state.verifyCode && !loading &&
                    <span>
                        <Form onSubmit={this.submitVerificationCode}>
                        <InputGroup className='edit-mobile-verification'>
                            <Input
                                value={verificationCode}
                                autoComplete='off'
                                placeholder='Enter Code'
                                onChange={this.handleVerificationCode}
                                type='text'
                                name="verificationCode"
                                invalid={invalidVerificationCode}
                            />
                            <InputGroupAddon addonType="append"><InputGroupText className='verification-button' onClick={this.submitVerificationCode}><a href='javascript:;'>Verify</a></InputGroupText></InputGroupAddon>
                            <FormFeedback className="m-0 p-0 text-center col-lg-12 float-right">
                                Incorrect Code or code expired. <br /> Please try again.
                            </FormFeedback>
                        </InputGroup>
                        <EirButton type='link' text='Resend Code' className='save' onClick={this.verification} />
                        <EirButton type='link' text='Cancel' className="cancel" onClick={this.handleCancel} />
                        </Form>
                    </span>
                }
                {
                    errorModal &&
                    <EirErrorModal toggleError={this.toggleError} errorModal={errorModal} />
                }
                {
                    this.state.loading &&
                    <Loading />
                }
            </div>
        )
    }
}

export default EditMobileNumber;
